import { render } from "./DonationsChart.vue?vue&type=template&id=0a559616"
import script from "./DonationsChart.vue?vue&type=script&lang=js"
export * from "./DonationsChart.vue?vue&type=script&lang=js"

import "./DonationsChart.vue?vue&type=style&index=0&id=0a559616&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__